export const copyString = (str: string, arr: Uint8Array, offset: number = 0) => {
    for (let i = 0; i < str.length; i += 1) {
        // eslint-disable-next-line no-bitwise
        arr[i + offset] = str.charCodeAt(i) & 0xff
    }
}
